import styled from "styled-components"

export const ErrorMsg = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(19px);
  color: #c91919;
  font-family: "Made Medium", sans-serif;
  font-size: 14px;
  letter-spacing: 0.21px;
  opacity: 0;
`

export const Label = styled.label`
  position: relative;
  width: 100%;
  .floating-label {
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 50%;
    transform: translateY(-25%);
    font-size: 20px;
    transition: all 0.3s ease;
    color: #808080;
    line-height: 10px;
  }
  input:focus ~ .floating-label,
  input:focus:invalid ~ .floating-label,
  .hasText {
    transform: translateY(-250%);
    font-size: 16px;
  }
`

export const StyledInput = styled.input`
  background: transparent;
  padding: 0;
  border: none;
  border-bottom: 1px solid #979797;
  outline: 0;
  line-height: normal;
  font-size: 20px;
  width: 100%;
  height: 40px;
  color: #000;
  &:focus {
    &:invalid {
      border-bottom: 1px solid #c91919;
      & ~ ${ErrorMsg} {
        opacity: 1;
      }
    }
  }
`
